import React from 'react';
import { Search, PenTool, Code2, Rocket, Layers, CheckCircle } from 'lucide-react';

const steps = [
  { id: '1', title: 'Discovery', icon: Search, desc: 'Analyze project requirements and goals.' },
  { id: '2', title: 'Planning', icon: Layers, desc: 'Define architecture and roadmap strategy.' },
  { id: '3', title: 'Design', icon: PenTool, desc: 'Create wireframes and intuitive interfaces.' },
  { id: '4', title: 'Development', icon: Code2, desc: 'Build scalable and secure functionality.' },
  { id: '5', title: 'Testing', icon: CheckCircle, desc: 'Ensure quality, performance, and security.' },
  { id: '6', title: 'Launch', icon: Rocket, desc: 'Deploy and maintain your digital product.' }
];

const DevelopmentProcess = () => {
  return (
    <section className="relative py-16 px-6 overflow-hidden bg-[#f8f8f8] dark:bg-[#050505] transition-colors duration-300">
      
      {/* 1. BACKGROUND GLOWS */}
  <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-primary/10 blur-[140px] rounded-full" />
      <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-orange-300/10 blur-[140px] rounded-full" />

      {/* GRID */}
      <div className="absolute inset-0 opacity-60 bg-[linear-gradient(to_right,rgba(0,0,0,0.06)_1px,transparent_1px),linear-gradient(to_bottom,rgba(0,0,0,0.06)_1px,transparent_1px)] dark:bg-[linear-gradient(to_right,rgba(255,255,255,0.06)_1px,transparent_1px),linear-gradient(to_bottom,rgba(255,255,255,0.06)_1px,transparent_1px)] bg-[size:60px_60px]" />

    <div className="text-center mb-12 md:mb-16">
                  <h2 className="myheading text-3xl md:text-5xl text-center">
         Our Development {" "}
            <span className="bg-gradient-to-r from-primary via-orange-400 to-yellow-500 bg-clip-text text-transparent">
              Process
            </span>
          </h2>
      <p className="myparagraph text-gray-500">
 A comprehensive 6-step approach to turn your vision into a high-performing reality.</p>
      </div>


      {/* 3. CONTENT WRAPPER */}
      <div className="relative z-10 max-w-7xl mx-auto">
     

        {/* Updated Grid for 6 steps */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative flex flex-col items-center text-center group">
              <div className="relative  z-10 w-16 h-16 bg-white dark:bg-[#1a1a1a] border border-orange-100 dark:border-orange-900/30 rounded-full flex items-center justify-center mb-6 shadow-sm group-hover:scale-110 transition-transform">
               
                <step.icon className="w-6 h-6 text-primary" />
              </div>
              <h3 className="text-lg font-bold text-gray-900 dark:text-white mb-2">
                {step.title}
              </h3>
              <p className="text-gray-600 hidden md:flex dark:text-gray-400 text-xs leading-relaxed">
                {step.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default DevelopmentProcess;